import React, { useState, useRef, useEffect } from "react";
import moment from "moment";
import defaultType1 from "../image/defaultType1.png";
import defaultType2 from "../image/defaultType2.png";
import detailBk from "../image/detailBk.png";
import audioPic from "../image/audioPic.png";
import videoPasue from "../image/pause.png";
import videoPlay from "../image/video.png";

const Detail = (props) => {
  let data = props.data;
  const {
    titlePic,
    title,
    publishDate,
    publishPhoto,
    publishType,
    variableFields,
    host
  } = data;
  const [isPlay, setIsPlay] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioPlayer = useRef(null);

  useEffect(() => {
    if (audioPlayer && audioPlayer.current) {
      var musicPlayer = document.getElementById("titlePic_id");
      if (!audioPlayer.current.paused) {
        setIsPlay(true);
        musicPlayer.style.animationPlayState = "running";
      } else {
        musicPlayer.style.animationPlayState = "paused";
      }
    }
  }, []);
  const handleSliderChange = (event) => {
    const { value } = event.target;
    setProgress(value);
    audioPlayer.current.currentTime = value;
  };

  const handleTimeUpdate = () => {
    let currentTime = audioPlayer.current.currentTime;
    let duration = audioPlayer.current.duration;
    setProgress(currentTime);
    setCurrentTime(s_to_hs(Math.ceil(currentTime)));
    setDuration(s_to_hs(Math.ceil(duration)));
    if (currentTime == duration) {
      var musicPlayer = document.getElementById("titlePic_id");
      musicPlayer.style.animationPlayState = "paused";
      setIsPlay(false);
    }
  };

  const s_to_hs = (s) => {
    //计算分钟
    //算法：将秒数除以60，然后下舍入，既得到分钟数
    var h;
    h = Math.floor(s / 60);
    //计算秒
    //算法：取得秒%60的余数，既得到秒数
    s = s % 60;
    //将变量转换为字符串
    h += "";
    s += "";
    //如果只有一位数，前面增加一个0
    h = h.length == 1 ? "0" + h : h;
    s = s.length == 1 ? "0" + s : s;
    return h + ":" + s;
  };

  return (
    <div
      style={{
        backgroundImage: `url(${detailBk})`,
        backgroundColor: "#000",
        backgroundSize: "cover",
        display:"flex",
        height:"100%",
        flexDirection:'column',
        alignItems:'center',
        justifyContent:"space-between",
        width:document.documentElement.clientWidth,
        maxWidth:677
      }}
    >
      <div
        style={{
          textAlign: "center",
          color: "#fff",
          fontSize: 12,
        }}
      >
        <div style={{ padding: 10,paddingBottom:0}}>
          <span
            style={{
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              wordBreak: "break-all",
              wordWarp: "break-word",
              overflow: "hidden",
              textOverflow: "ellipsis",
              WebkitLineClamp: 1,
              fontSize: 16,
              color: "#fff",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {title}
          </span>
        </div>
        <div style={{margin:10,color:"#fff"}}>
          <span style={{ marginRight: 10 }}>
            <img
              src={
                publishPhoto
                  ? publishPhoto
                  : publishType === 0
                  ? defaultType1
                  : defaultType2
              }
              style={{ width: 16, height: 16, verticalAlign: "middle" }}
              alt=""
            />
          </span>
          <span style={{ marginRight: 10 }}>{variableFields.publishName}</span>
          <span>{publishDate && moment(publishDate).format("YYYY-MM-DD")}</span>
        </div>
          <img
            src={titlePic ? titlePic : audioPic}
            style={{ width: 208, height: 208, borderRadius: "50%",marginTop:100  }}
            id="titlePic_id"
            className="animation_move"
            alt=""
          />
          
          {variableFields && variableFields.audioUrl && (
            <audio
              controls={false}
              autoPlay={true}
              controlsList="nodownload"
              width={"100%"}
              height={"100%"}
              src={host + variableFields.audioUrl}
              ref={audioPlayer}
              onTimeUpdate={() => handleTimeUpdate()}
            />
          )}
      </div>
      <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <img
            src={isPlay ? videoPasue : videoPlay}
            alt={""}
            onClick={(e) => {
              var musicPlayer = document.getElementById("titlePic_id");
              if (
                audioPlayer.current.duration > 0 &&
                !audioPlayer.current.paused
              ) {
                musicPlayer.style.animationPlayState = "paused";
                setIsPlay(false);
                audioPlayer.current.pause();
              } else {
                musicPlayer.style.animationPlayState = "running";
                setIsPlay(true);
                audioPlayer.current.play();
              }
            }}
            style={{
              width: "50px",
              height: "50px",
              objectFit: "cover",
              border: "1px solid #fff",
              borderRadius: "50%",
            }}
          />
          {duration ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height:100,
                marginTop: "50px",
              }}
            >
              <span style={{ color: "#fff" }}>{currentTime}</span>
              <input
                type="range"
                min="0"
                max={
                  audioPlayer.current && Math.ceil(audioPlayer.current.duration)
                }
                value={progress}
                onChange={handleSliderChange}
                className="progress-bar"
              />
              <span style={{ color: "#fff" }}>{duration}</span>
            </div>
          ) : (
            <div
              style={{
                width: "100%",
                height: 22,
                marginTop: "50px",
              }}
            />
          )}

        </div>
      <style>
        {`
                .animation_move {
                    animation: rotate 5s infinite linear;
                  }
                  
                  @keyframes rotate {
                    from {
                      transform: rotate(0deg);
                    }
                    to {
                      transform: rotate(360deg);
                    }
                  }
                  .progress-bar {
                    width: 250px;
                    height: 4px;
                    background-color: #ccc;
                    border-radius: 5px;
                    margin:0 5px;
                  }
                  
                  .progress-bar::-webkit-slider-thumb {
                    appearance: none;
                    width: 15px;
                    height: 15px;
                    background-color: #ff0000;
                    border-radius: 50%;
                  }
                  
                `}
      </style>
    </div>
  );
};

export default Detail;
